module.exports = __webpack_public_path__ + "img/ic_fitnessplan_add.25d87725.svg";